module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print:hidden"
  }, [_c('div', {
    staticClass: "flex items-center h-14 bg-white shadow w-full"
  }, [_c('button', {
    staticClass: "ml-8 block xl:hidden outline-0",
    class: {
      'ml-sidebar': _vm.showMenu === true
    },
    on: {
      "click": _vm.toggleShowMenu
    }
  }, [(!_vm.showMenu) ? _c('i', {
    staticClass: "material-icons text-blue-dark m-0"
  }, [_vm._v("\n        menu\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('i', {
    staticClass: "material-icons text-blue-dark m-0"
  }, [_vm._v("\n        close\n      ")]) : _vm._e()]), _vm._v(" "), _c('global-search', {
    staticClass: "ml-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center ml-auto mr-4"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$router.push("/cart-edit")
      }
    }
  }, [_c('icon', {
    staticClass: "w-6 mr-4 text-grey-light",
    attrs: {
      "name": "shopping-cart"
    }
  })], 1), _vm._v(" "), _c('NotificationSVG'), _vm._v(" "), _c('button', {
    staticClass: "flex items-center ml-3 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.showAccountLinks = !_vm.showAccountLinks
      }
    }
  }, [_c('div', {
    staticClass: "relative flex items-center"
  }, [_c('img', {
    staticClass: "h-8 w-8 rounded-full",
    attrs: {
      "src": _vm.user.gravatar
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons text-blue-dark"
  }, [_vm._v("\n            keyboard_arrow_down\n          ")]), _vm._v(" "), (_vm.showAccountLinks) ? _c('on-click-outside', {
    attrs: {
      "do": function () { return _vm.closeShowAccountLinks; }
    }
  }, [(_vm.showAccountLinks) ? _c('div', {
    staticClass: "absolute p-2 mt-12 rounded-sm pin-r shadow bg-white text-left z-20"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email == null),
      expression: "user.email == null"
    }],
    staticClass: "block p-1 px-3",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email !== null),
      expression: "user.email !== null"
    }],
    staticClass: "p-1 px-3 block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onLogout($event)
      }
    }
  }, [_vm._v("Logout")])], 1) : _vm._e()]) : _vm._e()], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708db87a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Navbar.vue
// module id = 591
// module chunks = 66